import { cn } from "@/lib/utils";
import { FIN_DISCLAIMER } from "@/lib/constants";

const TEMP = {
  Hot: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
  Warm: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30",
  Cold: "bg-sky-500/15 text-sky-600 dark:text-sky-400 border-sky-500/30",
  Review: "bg-indigo-500/15 text-indigo-600 dark:text-indigo-400 border-indigo-500/30",
  Rejected: "bg-slate-500/15 text-slate-600 dark:text-slate-400 border-slate-500/30",
};

export const TempBadge = ({ value, className }) => (
  <span data-testid={`temp-badge-${value}`} className={cn("score-pill", TEMP[value] || TEMP.Rejected, className)}>{value || "—"}</span>
);

export const ScoreBadge = ({ value, title }) => {
  const v = Number(value ?? 0);
  const cls = v >= 70 ? "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30"
    : v >= 45 ? "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30"
    : "bg-slate-500/10 text-slate-600 dark:text-slate-300 border-slate-500/25";
  return <span title={title} className={cn("score-pill", cls)}>{v}</span>;
};

export const FinBadge = ({ level, score }) => {
  const cls = { Strong: "text-emerald-600 dark:text-emerald-400 border-emerald-500/30", Moderate: "text-amber-600 dark:text-amber-400 border-amber-500/30",
    Limited: "text-sky-600 dark:text-sky-400 border-sky-500/30", Unknown: "text-muted-foreground border-border" }[level] || "text-muted-foreground border-border";
  return <span title={FIN_DISCLAIMER} className={cn("score-pill", cls)}>{level || "Unknown"} · {score ?? 0}</span>;
};

export const Chip = ({ on, children, onClick, testId }) => (
  <button type="button" data-testid={testId} onClick={onClick} className={cn("chip", on ? "on" : "off")}>{children}</button>
);

export const Empty = ({ title, hint, action, testId = "empty-state" }) => (
  <div data-testid={testId} className="panel p-10 text-center">
    <p className="font-semibold">{title}</p>
    {hint && <p className="text-sm text-muted-foreground mt-1">{hint}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const NotFound = ({ value }) => (value ? <span>{value}</span> : <span className="text-muted-foreground/70 italic text-xs">Not found</span>);
